// extracted by mini-css-extract-plugin
module.exports = {"profile":"contacts_profile__2JlSm","info":"contacts_info__1-cUE","infoLocation":"contacts_infoLocation__1qTlT","infoBody":"contacts_infoBody__yyA0a","map":"contacts_map__3GhvQ"};